export default {
    state: {
        activeNotification: null,
        redirect: null,
    },

    getters: {
        hasNotification(state) {
            return !!state.activeNotification;
        },
    },

    actions: {
        dismissNotification({ commit, state }) {
            if (state.activeNotification) {
                state.activeNotification.close();
                commit('SET_NOTIFICATION', null);
            }
        },

        async redirect({ state }, router) {
            if (state.redirect) {
                window.location.href = router.resolve(state.redirect).href;
            } else {
                window.location.href = '/';
            }
        },
    },

    mutations: {
        SET_NOTIFICATION(state, notification) {
            state.activeNotification = notification;
        },

        SET_REDIRECT(state, redirect) {
            state.redirect = redirect;
        },
    },
};
